import { Navigate, useLocation } from 'react-router-dom';
import { clearSession, getSession } from '@/lib/session';

type RequireAuthProps = {
  children: JSX.Element;
};

export default function RequireAuth({ children }: RequireAuthProps) {
  const session = typeof window !== 'undefined' ? getSession() : null;
  const location = useLocation();

  if (!session?.token || !session?.user) {
    if (typeof window !== 'undefined') {
      clearSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
